"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n    width: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 33.333333%;\n  width: calc(100% / 3);\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SelectionButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionButtonWrapper",
  componentId: "sc-10fasux-0"
})(_templateObject(), _responsiveBreakpoints.default.phone(_templateObject2()));

var _default = SelectionButtonWrapper;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/SelectionButtonWrapper.js
// module id = 806
// module chunks = 5 6